import { render, staticRenderFns } from "./Memberships.vue?vue&type=template&id=31770d80&"
import script from "./Memberships.vue?vue&type=script&lang=js&"
export * from "./Memberships.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports